export const ACCOUNT_BLOCKED_MESSAGE = "Your account has been blocked. Please contact support.";
